import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { TrackOticBrand } from '@/components/Brand';
import { useTrackOticAuth } from '@/context/TrackOticAuthContext';
import { qrPostPublic, safeNext } from './qrPublicApi';

export default function QrOtpLoginPage() {
  const [params] = useSearchParams();
  const next = safeNext(params.get('next'));
  const navigate = useNavigate();
  const { applySessionUser } = useTrackOticAuth();
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('phone');
  const [busy, setBusy] = useState(false);
  const [devOtp, setDevOtp] = useState(null);

  const request = async () => {
    setBusy(true);
    try {
      const r = await qrPostPublic('/auth/otp/request', { phone });
      setDevOtp(r.dev_otp || null);
      setStep('code');
    } catch (e) { toast.error(e.message); }
    setBusy(false);
  };

  const verify = async () => {
    setBusy(true);
    try {
      const r = await qrPostPublic('/auth/otp/verify', { phone, code });
      // Cookie-only (Phase 7): verify set the HttpOnly session cookie — no access_token in body.
      await applySessionUser(r.user, r.tenant);
      navigate(next, { replace: true });
    } catch (e) { toast.error(e.message); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex flex-col items-center px-6 pt-12" style={{ background: '#FAF9F6' }} data-testid="qr-otp-login">
      <TrackOticBrand size="xl" />
      <div className="w-full max-w-sm mt-8 rounded-2xl bg-white border p-6 space-y-4" style={{ borderColor: '#E5E3DC' }}>
        <h1 className="text-xl font-bold">Log in to bind</h1>
        {step === 'phone' ? (
          <>
            <label className="text-sm text-slate-500 block">Mobile number</label>
            <input data-testid="otp-phone" value={phone} onChange={e => setPhone(e.target.value)} inputMode="tel" autoFocus placeholder="+91 …"
              className="w-full h-12 rounded-lg border px-3 text-lg" style={{ borderColor: '#D9D6CD' }} onKeyDown={e => e.key === 'Enter' && request()} />
            <button data-testid="otp-request" onClick={request} disabled={busy || phone.replace(/\D/g, '').length < 6}
              className="w-full rounded-full py-3 font-bold text-white disabled:opacity-50" style={{ background: '#0B6B55' }}>{busy ? 'Sending…' : 'Send code'}</button>
          </>
        ) : (
          <>
            <p className="text-sm text-slate-500">Code sent to <span className="font-semibold">{phone}</span>.</p>
            {devOtp && <p className="text-xs rounded bg-amber-50 text-amber-800 p-2" data-testid="otp-dev-code">UAT stub (no SMS provider configured): code <span className="font-mono font-bold">{devOtp}</span></p>}
            <input data-testid="otp-code" value={code} onChange={e => setCode(e.target.value)} inputMode="numeric" autoFocus maxLength={8} placeholder="6-digit code"
              className="w-full h-12 rounded-lg border px-3 text-2xl tracking-[0.4em] text-center font-mono" style={{ borderColor: '#D9D6CD' }} onKeyDown={e => e.key === 'Enter' && verify()} />
            <button data-testid="otp-verify" onClick={verify} disabled={busy || code.length < 4}
              className="w-full rounded-full py-3 font-bold text-white disabled:opacity-50" style={{ background: '#0B6B55' }}>{busy ? 'Checking…' : 'Log in'}</button>
            <button onClick={() => setStep('phone')} className="w-full text-xs text-slate-500 underline">Change number</button>
          </>
        )}
      </div>
    </div>
  );
}
